import React from "react";
import { Mic } from "lucide-react";
import PageHeader from "@/components/admin/PageHeader";
import LockedFeatureCard from "@/components/admin/LockedFeatureCard";

export default function SettingsVoice() {
    return (
        <div className="p-10 max-w-5xl">
            <PageHeader eyebrow="Settings" title="Voice" description="Talk to Priya — voice in, voice out." testid="page-settings-voice" />
            <LockedFeatureCard
                title="Upgrade your plan to use Voice"
                description="Enable spoken conversations with Priya — natural voice in, natural voice out, with multi-language support. Available on Pro and above."
                icon={Mic}
                badge="Pro"
                actionLabel="Upgrade plan"
                testid="voice-locked"
                feature="voice"
            />
        </div>
    );
}
